/** Bandeira do Brasil, simplificada: sem a esfera celeste nem a faixa de texto. */
export function BrFlag({ size = 22 }: { size?: number }) {
  return (
    <svg width={size} height={size * 0.7} viewBox="0 0 28 20" aria-hidden="true" focusable="false">
      <rect width="28" height="20" fill="#009B3A" />
      <path d="M14 2.5 25.5 10 14 17.5 2.5 10Z" fill="#FEDF00" />
      <circle cx="14" cy="10" r="4.4" fill="#002776" />
    </svg>
  );
}
